import CallApi from '../hooks/callApi';

export async function fetchSessionStatus(sessionId) {
  return CallApi({
    method: 'GET',
    url: `/sessions/${encodeURIComponent(sessionId)}/status`,
  });
}

